import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkles2Bold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSparkles2Bold"><Path d="M14.65 7.5H13.35L11.725 11.725L7.5 13.35V14.65L11.725 16.275L13.35 20.5H14.65L16.275 16.275L20.5 14.65V13.35L16.275 11.725L14.65 7.5Z" stroke="currentColor"/><Path d="M7.35 3.5H6.65L5.775 5.775L3.5 6.65V7.35L5.775 8.225L6.65 10.5H7.35L8.225 8.225L10.5 7.35V6.65L8.225 5.775L7.35 3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconSparkles2Bold;
